import { type CommonAction, success } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";

export interface searchWeixinUserArticleParams extends ActiomCommonParams {
    fakeId: string;
    token: string | number;
}

export type PublishAction = CommonAction<searchWeixinUserArticleParams, Record<string, unknown>[]>;

export const searchWeixinUserArticle: PublishAction = async (_task, params) => {
    const { token } = params;
    if (!token) return { code: 414, message: "缺少token", data: [] };
    const fingerprint = "4695500bc93ab4ce8fb2692da6564e04";

    const http = new Http({
        headers: {
            cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        },
    });

    const publishInfo = await http.api<{ base_resp: { err_msg: string; ret: number }; publish_page: string }>(
        {
            method: "get",
            url: "https://mp.weixin.qq.com/cgi-bin/appmsgpublish",
            params: {
                token,
                lang: "zh_CN",
                fingerprint,
                f: "json",
                ajax: 1,
                sub: "list",
                search_field: null,
                begin: "0",
                count: "10",
                query: "",
                fakeid: params.fakeId,
                type: "101_1",
                free_publish_type: "1",
                sub_action: "list_ex",
            },
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const publishPage: { publish_list: Record<string, unknown>[] } = publishInfo.publish_page
        ? JSON.parse(publishInfo.publish_page)
        : { publish_list: [] };

    return success(publishPage.publish_list, "微信搜索账户数据成功！");
};
